import Component from "@tunnel-components/@pages/supervision/incident/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import {
  IncidentTypesLoadedActionCreator,
  IncidentInhibateGlobalLoadedActionCreator,
  IncidentRulesActionCreator,
  IncidentInhibateActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChangeRules
 * @name onChangeIncident
 * @name componentWillUnmount
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 100 millisecondes

  public debounceSubmit = Lodash.debounce((event: any) => {
    this.setState((state: any): any => ({
      checkedCONGESTIONError: false,
      checkedSLOWError: false,
      checkedSTOPPEDError9: false,
      checkedSTOPPEDError7: false,
      checkedSTOPPEDError5: false,
      checkedSTOPPEDError1: false,
      errorserver: false,
      success: false,
    }));
    // this.setState({});
    /**
     * @constant
     * @name rulesObject
     * @type any[]
     */
    const rulesObject: any[] = this.state.rulesObject;

    /**
     * @constant
     * @name slow
     * @type number
     */
    const slow: number =
      rulesObject.filter((elem: any) => elem.label === "SLOW").length > 0
        ? rulesObject.filter((elem: any) => elem.label === "SLOW")[0].maxSpeed
        : null;
    /**
     * @constant
     * @name stopped
     * @type number
     */
    const humain: number =
      rulesObject.filter((elem: any) => elem.label === "HUMAN").length > 0
        ? rulesObject.filter((elem: any) => elem.label === "HUMAN")[0]
            .minDuration
        : null;

    const stopped: number =
      rulesObject.filter((elem: any) => elem.label === "STOPPED").length > 0
        ? rulesObject.filter((elem: any) => elem.label === "STOPPED")[0]
            .minDuration
        : null;

    const slowduration: number =
      rulesObject.filter((elem: any) => elem.label === "SLOW").length > 0
        ? rulesObject.filter((elem: any) => elem.label === "SLOW")[0]
            .minDuration
        : null;

    const object: number =
      rulesObject.filter((elem: any) => elem.label === "OBJECT").length > 0
        ? rulesObject.filter((elem: any) => elem.label === "OBJECT")[0]
            .minDuration
        : null;

    /**
     * @constant
     * @name five
     * @type number
     */
    const five: number = 4;
    /**
     * @constant
     * @name one
     * @type number
     */
    const one: number = 1;
    /**
     * @constant
     * @name one
     * @type number
     */
    const sept: number = 8;
    /**
     * @constant
     * @name one
     * @type number
     */
    const dix: number = 11;
    /**
     * @constant
     * @name one
     * @type number
     */
    const cent: number = 101;
    const cond =
      (slow !== null && (slow >= cent || slow < five)) ||
      (humain !== null && (humain < one || humain >= dix)) ||
      (stopped !== null && (stopped < one || stopped >= dix)) ||
      (object !== null && (stopped < one || stopped >= dix)) ||
      (slowduration !== null && (slowduration < one || slowduration >= dix));

    if (cond) {
      if (slow <= five) {
        this.setState((state: any): any => ({ checkedSLOWError: true }));
      }
      if (slow >= cent) {
        this.setState((state: any): any => ({ checkedSLOWError: true }));
      }
      if (humain < one) {
        this.setState((state: any): any => ({ checkedSTOPPEDError9: true }));
      }
      if (stopped < one) {
        this.setState((state: any): any => ({ checkedSTOPPEDError7: true }));
      }
      if (object < one) {
        this.setState((state: any): any => ({ checkedSTOPPEDError5: true }));
      }
      if (slowduration < one) {
        this.setState((state: any): any => ({ checkedSTOPPEDError1: true }));
      }
      if (humain >= dix) {
        this.setState((state: any): any => ({ checkedSTOPPEDError9: true }));
      }
      if (stopped >= dix) {
        this.setState((state: any): any => ({ checkedSTOPPEDError7: true }));
      }
      if (object >= sept) {
        this.setState((state: any): any => ({ checkedSTOPPEDError5: true }));
      }
      if (slowduration >= dix) {
        this.setState((state: any): any => ({ checkedSTOPPEDError1: true }));
      }
    } else {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({ loading: true }));

      this.props
        .IncidentInhibateActionCreator(this.state)
        .then(() => this.setState((state: any): any => ({ loading: false })))
        .then(() => this.setState((state: any): any => ({ success: true })));
    }
  }, 100);
  //  faire cette action toute les 100 millisecondes

  //  faire cette action toute les 100 millisecondes
  public debounceChangeIncident = Lodash.debounce((param: any, event: any) => {
    /**
     * @constant
     * @name checked
     * @type boolean[]
     */
    const checked: any[] = [];
    /**
     * @constant
     * @description :
     * @name incidenTypeIdentifiant
     * @type number[]
     */
    const identifiantIncident: any[] = [];
    {
      /** Boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.checked.length); i++) {
      checked[i] = this.state.checked[i];
      identifiantIncident[i] = this.state.identifiantIncident[i];
    }
    checked[param] = !this.state.checked[param];
    {
      /** Comparaison */
    }
    if (checked[param] === true) {
      identifiantIncident[param] = { id: Number(event.target.id) };
    } else {
      identifiantIncident[param] = null;
    }
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      checked,
      checkedCONGESTIONError: false,
      checkedSLOWError: false,
      checkedSTOPPEDError9: false,
      checkedSTOPPEDError7: false,
      checkedSTOPPEDError5: false,
      checkedSTOPPEDError1: false,
      identifiantIncident,
      success: false,
    }));
  }, 100);
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      checked: [],
      checkedCONGESTIONError: false,
      checkedSLOWError: false,
      checkedSTOPPEDError9: false,
      checkedSTOPPEDError7: false,
      checkedSTOPPEDError5: false,
      checkedSTOPPEDError1: false,
      identifiantIncident: [],

      minDuration: [],
      maxSpeed: [],
      nbElement: [],
      success: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChangeDuration = this.onChangeDuration.bind(this);
    this.onChangeSpeed = this.onChangeSpeed.bind(this);
    this.onChangeElement = this.onChangeElement.bind(this);

    this.onChangeIncident = this.onChangeIncident.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  /**
   * MAJ des inputs
   * @public
   * @method onChangeIncident
   * @param { any } event
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onChangeIncident = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChangeIncident(param, event);
  };
  /**
   * MAJ des inputs
   * @public
   * @method onChangeDuration
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangeDuration = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    // this.debounceChangeRules(param , event);
    {
      /** vérification de l'existence de l'élement  */
    }
    /**
     * @constant
     * @name minDuration
     * @type boolean[]
     */
    const minDuration: any[] = [];
    /**
     * @constant
     * @name rulesObject
     * @type any[]
     */
    const rulesObject: any[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.minDuration.length); i++) {
      minDuration.push(this.state.minDuration[i]);
      rulesObject.push(this.state.rulesObject[i]);
    }
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      Lodash.isNumber(Number(event.target.value)) &&
      Number(event.target.value) >= 0 &&
      Number(event.target.value) <= 100
    ) {
      minDuration[param] = Number(event.target.value);
      rulesObject[param].minDuration = Number(event.target.value);

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        checkedCONGESTIONError: false,
        checkedSLOWError: false,
        checkedSTOPPEDError9: false,
        checkedSTOPPEDError7: false,
        checkedSTOPPEDError5: false,
        checkedSTOPPEDError1: false,
        minDuration,
        rulesObject,
        success: false,
      }));
    }
  };

  /**
   * MAJ des inputs
   * @public
   * @method onChangeSpeed
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangeSpeed = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    // this.debounceChangeRules(param , event);
    {
      /** vérification de l'existence de l'élement  */
    }
    /**
     * @constant
     * @name maxSpeed
     * @type boolean[]
     */
    const maxSpeed: any[] = [];
    /**
     * @constant
     * @name rulesObject
     * @type any[]
     */
    const rulesObject: any[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.maxSpeed.length); i++) {
      maxSpeed.push(this.state.maxSpeed[i]);
      rulesObject.push(this.state.rulesObject[i]);
    }
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      Lodash.isNumber(Number(event.target.value)) &&
      Number(event.target.value) >= 0 &&
      Number(event.target.value) <= 110
    ) {
      maxSpeed[param] = Number(event.target.value);
      rulesObject[param].maxSpeed = Number(event.target.value);
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      checkedCONGESTIONError: false,
      checkedSLOWError: false,
      checkedSTOPPEDError9: false,
      checkedSTOPPEDError7: false,
      checkedSTOPPEDError5: false,
      checkedSTOPPEDError1: false,
      maxSpeed,
      rulesObject,
      success: false,
    }));
  };
  /**
   * MAJ des inputs
   * @public
   * @method onChangeElement
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChangeElement = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    // this.debounceChangeRules(param , event);
    {
      /** vérification de l'existence de l'élement  */
    }
    /**
     * @constant
     * @name nbElement
     * @type boolean[]
     */
    const nbElement: any[] = [];
    /**
     * @constant
     * @name rulesObject
     * @type any[]
     */
    const rulesObject: any[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.nbElement.length); i++) {
      nbElement.push(this.state.nbElement[i]);
      rulesObject.push(this.state.rulesObject[i]);
    }
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      Lodash.isNumber(Number(event.target.value)) &&
      Number(event.target.value) >= 0 &&
      Number(event.target.value) <= 100
    ) {
      nbElement[param] = Number(event.target.value);
      rulesObject[param].nbElement = Number(event.target.value);
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      checkedCONGESTIONError: false,
      checkedSLOWError: false,
      checkedSTOPPEDError9: false,
      checkedSTOPPEDError7: false,
      checkedSTOPPEDError5: false,
      checkedSTOPPEDError1: false,
      nbElement,
      rulesObject,
      success: false,
    }));
  };
  /**
   * MAJ des inputs
   * @public
   * @method onSubmit
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSubmit(event);
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison */
    }
    if (prevState.incidentTypes !== this.state.incidentTypes) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(this.state.incidentTypes)) {
        /**
         * @constant
         * @name checked
         * @type boolean[]
         */
        const checked: boolean[] = [];
        /**
         * @constant
         * @name identifiantIncident
         * @type any[]
         */
        const identifiantIncident: any[] = [];
        /**
         * @constant
         * @name rules
         * @type any[]
         */
        // const rules: any[] = [];
        const minDuration: any[] = [];
        const maxSpeed: any[] = [];
        const nbElement: any[] = [];

        /**
         * @constant
         * @name rulesObject
         * @type any[]
         */
        const rulesObject: any[] = [];

        {
          /** boucle */
        }
        for (let i = 0; i < Math.ceil(this.state.incidentTypes.length); i++) {
          {
            /** vérification de l'existence de l'élement  */
          }
          if (!Lodash.isUndefined(this.state.incidentTypes)) {
            // rules.push(this.state.incidentTypes[i].rule);
            minDuration.push(this.state.incidentTypes[i].minDuration);
            maxSpeed.push(this.state.incidentTypes[i].maxSpeed);
            nbElement.push(this.state.incidentTypes[i].nbElement);
            /**
             * @deprecated
             */
            // rulesObject.push({'id':this.state.incidentTypes[i].id, 'rule':this.state.incidentTypes[i].rule})
            /**
             *
             */
            rulesObject.push({
              id: this.state.incidentTypes[i].id,
              label: this.state.incidentTypes[i].label,
              minDuration: this.state.incidentTypes[i].minDuration,
              maxSpeed: this.state.incidentTypes[i].maxSpeed,
              nbElement: this.state.incidentTypes[i].nbElement,
            });
            {
              /** vérification de l'existence de l'élement  */
            }
            if (!Lodash.isUndefined(this.props.getGlobalInhibition)) {
              /**
               * @constant
               * @name findElementIn2DifferentArray
               * @types any[]
               */

              const findElementIn2DifferentArray: any[] =
                !Lodash.isNull(
                  this.props.getGlobalInhibition.first.incidentTypes
                ) &&
                this.props.getGlobalInhibition.first.incidentTypes.filter(
                  (elem: any) => elem.id === this.state.incidentTypes[i].id
                );

              checked.push(findElementIn2DifferentArray.length === 1);
              // identifiantIncident.push(findElementIn2DifferentArray[i]);

              if (findElementIn2DifferentArray.length === 1) {
                identifiantIncident[i] = {
                  id: findElementIn2DifferentArray[0].id,
                };
              } else {
                identifiantIncident[i] = null;
              }
            }
          }
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          checked,
          identifiantIncident,
          /*rules */ maxSpeed,
          minDuration,
          nbElement,
          rulesObject,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    // Stopper l'action une fois le component détruit
    // this.debounceChangeRules.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceSubmit.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceChangeIncident.cancel();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorserver: true }));
      }
      {
        /** Comparaison */
      }
    } else if (nextProps.getIncidentTypes !== this.props.getIncidentTypes) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.getIncidentTypes)) {
        /**
         * @constant
         * @name incidentTypes
         * @type any[]
         */

        /**
         * @deprecated
         */
        // const incidentTypes : any[] = nextProps.getIncidentTypes.filter((elem: any) => elem.id !==2 && elem.id !== 3)

        const incidentTypes: any[] = nextProps.getIncidentTypes;
        {
          /** Empêcher la mutation du state */
        }
        this.setState({ incidentTypes });
      } else if (!Lodash.isUndefined(this.props.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorserver: true }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));

    this.props
      .IncidentInhibateGlobalLoadedActionCreator()
      .then(() => this.props.IncidentTypesLoadedActionCreator())
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */

  public render() {
    return (
      <Component
        onChangeDuration={this.onChangeDuration}
        onChangeSpeed={this.onChangeSpeed}
        onChangeElement={this.onChangeElement}
        onChangeIncident={this.onChangeIncident}
        onSubmit={this.onSubmit}
        {...this.state}
        {...this.props}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    error: state.IncidentTypesLoaded.error,
    getGlobalInhibition: state.IncidentInhibateGlobalLoaded.data,
    getIncidentTypes: state.IncidentTypesLoaded.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  IncidentTypesLoadedActionCreator,
  IncidentInhibateGlobalLoadedActionCreator,
  IncidentRulesActionCreator,
  IncidentInhibateActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/incident/home/container.tsx